import { useState, useCallback } from 'react';
import { handleApiError } from '../services/api';

/**
 * API 에러 처리를 위한 커스텀 훅
 * 
 * @example
 * const { error, showError, clearError } = useApiError();
 * 
 * try {
 *   await api.someCall();
 * } catch (err) {
 *   showError(err);
 * }
 */
const useApiError = () => {
  const [error, setError] = useState(null);

  const showError = useCallback((apiError, customMessage = null) => {
    const errorInfo = handleApiError(apiError, customMessage);
    setError(errorInfo);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    error,
    showError,
    clearError,
    hasError: error !== null
  };
};

export default useApiError;

